<template>
	<div class="ca-interventions">
		<h3 class="title title-page text-primary font-medium">Interventions</h3>

		<list-interventions-table></list-interventions-table>
	</div>
</template>

<script>
import ListInterventionsTable from "../../../components/ClientsArea/Interventions/ListInterventionsTable";

export default {
	name: "ClientsAreaInterventions",
	components: {
		ListInterventionsTable
	}
}
</script>

<style scoped lang="scss">

</style>
